import _ from "lodash";
import React, { useEffect, useState } from "react";
import ReactDOM from "react-dom";

function TicTacToe() {
    const [a1Box, setA1Box] = useState(null);
    const [a2Box, setA2Box] = useState(null);
    const [a3Box, setA3Box] = useState(null);
    const [b1Box, setB1Box] = useState(null);
    const [b2Box, setB2Box] = useState(null);
    const [b3Box, setB3Box] = useState(null);
    const [c1Box, setC1Box] = useState(null);
    const [c2Box, setC2Box] = useState(null);
    const [c3Box, setC3Box] = useState(null);

    const [forceRerender, setForceRerender] = useState(1);
    const [rerenderDraw, setRerenderDraw] = useState(1);
    const [userPlayFirst, setUserPlayFirst] = useState(true);
    const [userTurn, setUserPlayTurn] = useState(true);

    const [win, setWin] = useState(null);
    const [userScore, setUserScore] = useState(0);
    const [pcScore, setPcScore] = useState(0);
    const [draw, setDraw] = useState(false);

    const [isDisabled, setIsDisabled] = useState(false);

    useEffect(() => {
        checkWin();
    }, [a1Box, a2Box, a3Box, b1Box, b2Box, b3Box, c1Box, c2Box, c3Box]);

    useEffect(() => {
        if (!userPlayFirst || forceRerender >= 2) {
            pcPlay();
        }
    }, [forceRerender]);

    useEffect(() => {
        if (win === null && rerenderDraw >= 4) {
            checkDraw();
        }
    }, [rerenderDraw]);

    function checkDraw() {
        if (
            win === null &&
            a1Box !== null &&
            a2Box !== null &&
            a3Box !== null &&
            b1Box !== null &&
            b2Box !== null &&
            b3Box !== null &&
            c1Box !== null &&
            c2Box !== null &&
            c3Box !== null
        ) {
            setDraw(true);
        }
    }

    function checkWin() {
        if (a1Box && a2Box && a3Box) {
            setWin(true);
            setUserScore(userScore + 1);
            setIsDisabled(true);
        } else if (a1Box === false && a2Box === false && a3Box === false) {
            setWin(false);
            setPcScore(pcScore + 1);
            setIsDisabled(true);
        }

        if (a1Box && b1Box && c1Box) {
            setWin(true);
            setUserScore(userScore + 1);
            setIsDisabled(true);
        } else if (a1Box === false && b1Box === false && c1Box === false) {
            setWin(false);
            setPcScore(pcScore + 1);
            setIsDisabled(true);
        }

        if (a1Box && b2Box && c3Box) {
            setWin(true);
            setUserScore(userScore + 1);
            setIsDisabled(true);
        } else if (a1Box === false && b2Box === false && c3Box === false) {
            setWin(false);
            setPcScore(pcScore + 1);
            setIsDisabled(true);
        }

        if (a2Box && b2Box && c2Box) {
            setWin(true);
            setUserScore(userScore + 1);
            setIsDisabled(true);
        } else if (a2Box === false && b2Box === false && c2Box === false) {
            setWin(false);
            setPcScore(pcScore + 1);
            setIsDisabled(true);
        }

        if (a3Box && b3Box && c3Box) {
            setWin(true);
            setUserScore(userScore + 1);
            setIsDisabled(true);
        } else if (a3Box === false && b3Box === false && c3Box === false) {
            setWin(false);
            setPcScore(pcScore + 1);
            setIsDisabled(true);
        }

        if (a3Box && b2Box && c1Box) {
            setWin(true);
            setUserScore(userScore + 1);
            setIsDisabled(true);
        } else if (a3Box === false && b2Box === false && c1Box === false) {
            setWin(false);
            setPcScore(pcScore + 1);
            setIsDisabled(true);
        }

        if (b1Box && b2Box && b3Box) {
            setWin(true);
            setUserScore(userScore + 1);
            setIsDisabled(true);
        } else if (b1Box === false && b2Box === false && b3Box === false) {
            setWin(false);
            setPcScore(pcScore + 1);
            setIsDisabled(true);
        }

        if (c1Box && c2Box && c3Box) {
            setWin(true);
            setUserScore(userScore + 1);
            setIsDisabled(true);
        } else if (c1Box === false && c2Box === false && c3Box === false) {
            setWin(false);
            setPcScore(pcScore + 1);
            setIsDisabled(true);
        }

        setRerenderDraw(rerenderDraw + 1);
    }

    async function clickedBox(event) {
        let userClick = event.currentTarget.id;

        // A
        if (userClick === "a1" && a1Box !== false) {
            setA1Box(true);
            await new Promise((resolve) => setTimeout(resolve, 20));
            setForceRerender(forceRerender + 1);
        }

        if (userClick === "a2" && a2Box !== false) {
            setA2Box(true);
            await new Promise((resolve) => setTimeout(resolve, 20));
            setForceRerender(forceRerender + 1);
        }

        if (userClick === "a3" && a3Box !== false) {
            setA3Box(true);
            await new Promise((resolve) => setTimeout(resolve, 20));
            setForceRerender(forceRerender + 1);
        }

        // B
        if (userClick === "b1" && b1Box !== false) {
            setB1Box(true);
            await new Promise((resolve) => setTimeout(resolve, 20));
            setForceRerender(forceRerender + 1);
        }

        if (userClick === "b2" && b2Box !== false) {
            setB2Box(true);
            await new Promise((resolve) => setTimeout(resolve, 20));
            setForceRerender(forceRerender + 1);
        }

        if (userClick === "b3" && b3Box !== false) {
            setB3Box(true);
            await new Promise((resolve) => setTimeout(resolve, 20));
            setForceRerender(forceRerender + 1);
        }

        // C
        if (userClick === "c1" && c1Box !== false) {
            setC1Box(true);
            await new Promise((resolve) => setTimeout(resolve, 20));
            setForceRerender(forceRerender + 1);
        }

        if (userClick === "c2" && c2Box !== false) {
            setC2Box(true);
            await new Promise((resolve) => setTimeout(resolve, 20));
            setForceRerender(forceRerender + 1);
        }

        if (userClick === "c3" && c3Box !== false) {
            setC3Box(true);
            await new Promise((resolve) => setTimeout(resolve, 20));
            setForceRerender(forceRerender + 1);
        }
    }

    async function pcPlay() {
        setIsDisabled(true);
        setUserPlayTurn(false);

        const deff_arr = [true, true, null];
        const att_arr = [false, false, null];
        const next_move_clear = [false, null, null];
        const next_move = [false, true, null];
        const thinkingTime = Math.floor(Math.random() * (1500 - 600) + 600);

        let num = 0;
        let giveRandom = false;

        let winPoss = [
            [
                ["a1Box", a1Box],
                ["a2Box", a2Box],
                ["a3Box", a3Box],
            ],
            [
                ["b1Box", b1Box],
                ["b2Box", b2Box],
                ["b3Box", b3Box],
            ],
            [
                ["c1Box", c1Box],
                ["c2Box", c2Box],
                ["c3Box", c3Box],
            ],
            [
                ["a1Box", a1Box],
                ["b1Box", b1Box],
                ["c1Box", c1Box],
            ],
            [
                ["a2Box", a2Box],
                ["b2Box", b2Box],
                ["c2Box", c2Box],
            ],
            [
                ["a3Box", a3Box],
                ["b3Box", b3Box],
                ["c3Box", c3Box],
            ],
            [
                ["a1Box", a1Box],
                ["b2Box", b2Box],
                ["c3Box", c3Box],
            ],
            [
                ["a3Box", a3Box],
                ["b2Box", b2Box],
                ["c1Box", c1Box],
            ],
        ];

        if (forceRerender >= 2) {
            await new Promise((resolve) => setTimeout(resolve, thinkingTime));
        } else {
            await new Promise((resolve) => setTimeout(resolve, 400));
        }

        if (win !== null || draw === true) {
            return;
        }

        if (b2Box === null) {
            setB2Box(false);
            setIsDisabled(false);
            setUserPlayTurn(true);
            return;
        }

        let defUser = [];

        //  1st check if pc can win
        for (let i = 0; i < winPoss.length; i++) {
            let push_arr_false = [];
            let check_pc = [];

            let sorted_arr_false = winPoss[i].sort(function (x, y) {
                // false values first
                if (x[1] === null) {
                    return 1;
                }
                if (y[1] === null) {
                    return -1;
                }
                if (x[1] === y[1]) {
                    return 0;
                }

                return x[1] < y[1] ? -1 : 1;
            });
            push_arr_false.push(sorted_arr_false);

            for (let j = 0; j < winPoss[i].length; j++) {
                check_pc.push(push_arr_false[0][j][1]);

                if (_.isEqual(check_pc, att_arr)) {
                    // win
                    defUser.push(winPoss[i][2][0]);
                    break;
                }
            }
        }

        // 2nd check if user gonna win and prevent it
        if (defUser.length === 0) {
            for (let i = 0; i < winPoss.length; i++) {
                let push_arr_true = [];
                let check_user = [];

                let sorted_arr_true = winPoss[i].sort(function (x, y) {
                    // true values first
                    return x[1] === y[1] ? 0 : x[1] ? -1 : 1;
                });
                push_arr_true.push(sorted_arr_true);

                for (let j = 0; j < winPoss[i].length; j++) {
                    check_user.push(push_arr_true[0][j][1]);

                    if (_.isEqual(check_user, deff_arr)) {
                        //prevent user to win
                        defUser.push(winPoss[i][2][0]);
                        break;
                    }
                }
            }
        }

        // else just make the next move
        // Clear move
        if (defUser.length === 0) {
            for (let i = 0; i < winPoss.length; i++) {
                let push_arr_false = [];
                let check_pc = [];

                let sorted_arr_false = winPoss[i].sort(function (x, y) {
                    if (x[1] === null) {
                        return 1;
                    }
                    if (y[1] === null) {
                        return -1;
                    }
                    if (x[1] === y[1]) {
                        return 0;
                    }

                    return x[1] < y[1] ? -1 : 1;
                });
                push_arr_false.push(sorted_arr_false);

                for (let j = 0; j < winPoss[i].length; j++) {
                    check_pc.push(push_arr_false[0][j][1]);

                    if (_.isEqual(check_pc, next_move_clear)) {
                        //just play next move
                        defUser.push(winPoss[i][2][0]);
                        break;
                    }
                }
            }
        }

        // or Next move
        if (defUser.length === 0) {
            for (let i = 0; i < winPoss.length; i++) {
                let push_arr_false = [];
                let check_pc = [];

                let sorted_arr_false = winPoss[i].sort(function (x, y) {
                    if (x[1] === null) {
                        return 1;
                    }
                    if (y[1] === null) {
                        return -1;
                    }
                    if (x[1] === y[1]) {
                        return 0;
                    }

                    return x[1] < y[1] ? -1 : 1;
                });
                push_arr_false.push(sorted_arr_false);

                for (let j = 0; j < winPoss[i].length; j++) {
                    check_pc.push(push_arr_false[0][j][1]);

                    if (_.isEqual(check_pc, next_move)) {
                        //just play next move
                        defUser.push(winPoss[i][2][0]);
                        break;
                    }
                }
            }
        }

        // random move
        if (defUser.length === 0) {
            for (let i = 0; i < winPoss.length; i++) {
                let push_arr_false = [];
                let check_pc = [];

                let sorted_arr_false = winPoss[i].sort(function (x, y) {
                    if (x[1] === null) {
                        return 1;
                    }
                    if (y[1] === null) {
                        return -1;
                    }
                    if (x[1] === y[1]) {
                        return 0;
                    }

                    return x[1] < y[1] ? -1 : 1;
                });
                push_arr_false.push(sorted_arr_false);

                for (let j = 0; j < winPoss[i].length; j++) {
                    check_pc.push(push_arr_false[0][j][1]);

                    giveRandom = true;
                    defUser.push(winPoss[i][2][0]);
                    break;
                }
            }
        }

        if (giveRandom) {
            num = Math.floor(Math.random() * 8);
        }

        if (defUser[num] === "a1Box") {
            setA1Box(false);
        }
        if (defUser[num] === "a2Box") {
            setA2Box(false);
        }
        if (defUser[num] === "a3Box") {
            setA3Box(false);
        }
        if (defUser[num] === "b1Box") {
            setB1Box(false);
        }
        if (defUser[num] === "b2Box") {
            setB2Box(false);
        }
        if (defUser[num] === "b3Box") {
            setB3Box(false);
        }
        if (defUser[num] === "c1Box") {
            setC1Box(false);
        }
        if (defUser[num] === "c2Box") {
            setC2Box(false);
        }
        if (defUser[num] === "c3Box") {
            setC3Box(false);
        }

        setRerenderDraw(rerenderDraw + 1);
        setTimeout(() => {
            setUserPlayTurn(true);
        }, 500);
        setIsDisabled(false);
    }

    function playAgain() {
        setWin(null);
        setDraw(false);
        setIsDisabled(false);
        setA1Box(null);
        setA2Box(null);
        setA3Box(null);
        setB1Box(null);
        setB2Box(null);
        setB3Box(null);
        setC1Box(null);
        setC2Box(null);
        setC3Box(null);
        setUserPlayFirst((prevUserPlayFirst) => !prevUserPlayFirst);
        setForceRerender(1);
        setRerenderDraw(1);
    }

    function renderX() {
        return (
            <g>
            <path
                className="path"
                d="M33,7.5 L39,1.5"
                id="x2"
                stroke="#FEB4BE"
            ></path>
            <path
                className="path"
                d="M33,0.5 L39,7"
                id="x1"
                stroke="#FEB4BE"
            ></path>
        </g>)
    }

    function renderO() {
       return (
        <path
        className="path2"
        d="M35,0.5 C37,0.5 38,1 38,2.5 L38,4.5 C38,5 37,6.5 36,6.5 C34,6.5 34,5 34,4.5 L34,2.5 C34,1 34,0.5 37,0.5 Z"
        id="o"
        stroke="aqua"
    ></path>
       )
    }

    return (
        <div className="container">
            <div className="row justify-content-center">
                <div className="col-md-8">
                    <div className="d-flex flex-column">
                        <div className="d-flex flex-column">
                            <div className="w-100 text-center winStyle my-3">
                                {draw ? (
                                    "Draw!"
                                ) : (
                                    <div>
                                        {win !== null && (
                                            <>
                                                {win
                                                    ? "You Win!!"
                                                    : "Computer Win!!"}
                                            </>
                                        )}
                                    </div>
                                )}
                            </div>
                            <div
                                className="d-flex justify-content-between mb-3 align-items-end"
                                style={{ height: 45 }}
                            >
                                <div className="score">
                                    Your Score: {userScore}
                                </div>
                                <div className="score">Pc Score: {pcScore}</div>
                            </div>
                            <div className="d-flex justify-content-between mb-3">
                                <div className="d-flex flex-column">
                                    <i
                                        className="fas fa-user-secret mb-1"
                                        style={{
                                            fontSize: 60,
                                            color: "#FEB4BE",
                                        }}
                                    ></i>
                                    <div style={{ height: 24 }}>
                                        {userTurn && win === null && !draw && (
                                            <span>Your turn!</span>
                                        )}
                                    </div>
                                </div>
                                <div className="d-flex flex-column">
                                    <i
                                        className="fas fa-robot"
                                        style={{
                                            fontSize: 60,
                                            color: "aqua",
                                        }}
                                    ></i>
                                    <div className="position-relative">
                                        {!userTurn && win === null && !draw && (
                                            <div className="position-relative">
                                                <i className="gear"></i>
                                                <i className="gear"></i>
                                            </div>
                                        )}
                                        <div>
                                            {win === false && (
                                                <span className="speech-bubble">
                                                    Easy!
                                                </span>
                                            )}
                                            {win === true && (
                                                <span className="speech-bubble">
                                                    Lucky!
                                                </span>
                                            )}
                                            {draw && (
                                                <span className="speech-bubble">
                                                    Meh!
                                                </span>
                                            )}
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>

                        {/* A */}
                        <div className="d-flex justify-content-center">
                            <button
                                id="a1"
                                className="d-flex justify-content-center align-items-center"
                                onClick={clickedBox}
                                disabled={isDisabled || a1Box !== null || win || win === false}
                            >
                                <svg viewBox="31 -4 10 15">
                                    <g
                                        id="Page-1"
                                        stroke="none"
                                        strokeWidth="1"
                                        fill="none"
                                        fillRule="evenodd"
                                    >
                                        <g
                                            id="Group"
                                            strokeLinecap="round"
                                            strokeLinejoin="round"
                                            strokeWidth="1"
                                        >
                                            {a1Box !== null && (
                                                <>
                                                    {a1Box ? (
                                                        renderX()
                                                    ) : (
                                                        renderO()
                                                    )}
                                                </>
                                            )}
                                        </g>
                                    </g>
                                </svg>
                            </button>
                            <button
                                id="a2"
                                className="d-flex justify-content-center align-items-center"
                                onClick={clickedBox}
                                disabled={isDisabled || a2Box !== null || win || win === false}
                            >
                                <svg viewBox="31 -4 10 15">
                                    <g
                                        id="Page-1"
                                        stroke="none"
                                        strokeWidth="1"
                                        fill="none"
                                        fillRule="evenodd"
                                    >
                                        <g
                                            id="Group"
                                            strokeLinecap="round"
                                            strokeLinejoin="round"
                                            strokeWidth="1"
                                        >
                                            {a2Box !== null && (
                                                <>
                                                    {a2Box ? (
                                                        renderX()
                                                        ) : (
                                                        renderO()
                                                    )}
                                                </>
                                            )}
                                        </g>
                                    </g>
                                </svg>
                            </button>
                            <button
                                id="a3"
                                className="d-flex justify-content-center align-items-center"
                                onClick={clickedBox}
                                disabled={isDisabled || a3Box !== null || win || win === false}
                            >
                                <svg viewBox="31 -4 10 15">
                                    <g
                                        id="Page-1"
                                        stroke="none"
                                        strokeWidth="1"
                                        fill="none"
                                        fillRule="evenodd"
                                    >
                                        <g
                                            id="Group"
                                            strokeLinecap="round"
                                            strokeLinejoin="round"
                                            strokeWidth="1"
                                        >
                                            {a3Box !== null && (
                                                <>
                                                    {a3Box ? (
                                                        renderX()
                                                        ) : (
                                                        renderO()
                                                    )}
                                                </>
                                            )}
                                        </g>
                                    </g>
                                </svg>
                            </button>
                        </div>

                        {/* B */}
                        <div className="d-flex justify-content-center">
                            <button
                                id="b1"
                                className="d-flex justify-content-center align-items-center"
                                onClick={clickedBox}
                                disabled={isDisabled || b1Box !== null || win || win === false}
                            >
                                <svg viewBox="31 -4 10 15">
                                    <g
                                        id="Page-1"
                                        stroke="none"
                                        strokeWidth="1"
                                        fill="none"
                                        fillRule="evenodd"
                                    >
                                        <g
                                            id="Group"
                                            strokeLinecap="round"
                                            strokeLinejoin="round"
                                            strokeWidth="1"
                                        >
                                            {b1Box !== null && (
                                                <>
                                                    {b1Box ? (
                                                        renderX()
                                                        ) : (
                                                        renderO()
                                                    )}
                                                </>
                                            )}
                                        </g>
                                    </g>
                                </svg>
                            </button>
                            <button
                                id="b2"
                                className="d-flex justify-content-center align-items-center"
                                onClick={clickedBox}
                                disabled={isDisabled || b2Box !== null || win || win === false}
                            >
                                <svg viewBox="31 -4 10 15">
                                    <g
                                        id="Page-1"
                                        stroke="none"
                                        strokeWidth="1"
                                        fill="none"
                                        fillRule="evenodd"
                                    >
                                        <g
                                            id="Group"
                                            strokeLinecap="round"
                                            strokeLinejoin="round"
                                            strokeWidth="1"
                                        >
                                            {b2Box !== null && (
                                                <>
                                                    {b2Box ? (
                                                        renderX()
                                                        ) : (
                                                        renderO()
                                                    )}
                                                </>
                                            )}
                                        </g>
                                    </g>
                                </svg>
                            </button>
                            <button
                                id="b3"
                                className="d-flex justify-content-center align-items-center"
                                onClick={clickedBox}
                                disabled={isDisabled || b3Box !== null || win || win === false}
                            >
                                <svg viewBox="31 -4 10 15">
                                    <g
                                        id="Page-1"
                                        stroke="none"
                                        strokeWidth="1"
                                        fill="none"
                                        fillRule="evenodd"
                                    >
                                        <g
                                            id="Group"
                                            strokeLinecap="round"
                                            strokeLinejoin="round"
                                            strokeWidth="1"
                                        >
                                            {b3Box !== null && (
                                                <>
                                                    {b3Box ? (
                                                        renderX()
                                                        ) : (
                                                        renderO()
                                                    )}
                                                </>
                                            )}
                                        </g>
                                    </g>
                                </svg>
                            </button>
                        </div>

                        {/* C */}
                        <div className="d-flex justify-content-center">
                            <button
                                id="c1"
                                className="d-flex justify-content-center align-items-center"
                                onClick={clickedBox}
                                disabled={isDisabled || c1Box !== null || win || win === false}
                            >
                                <svg viewBox="31 -4 10 15">
                                    <g
                                        id="Page-1"
                                        stroke="none"
                                        strokeWidth="1"
                                        fill="none"
                                        fillRule="evenodd"
                                    >
                                        <g
                                            id="Group"
                                            strokeLinecap="round"
                                            strokeLinejoin="round"
                                            strokeWidth="1"
                                        >
                                            {c1Box !== null && (
                                                <>
                                                    {c1Box ? (
                                                        renderX()
                                                        ) : (
                                                        renderO()
                                                    )}
                                                </>
                                            )}
                                        </g>
                                    </g>
                                </svg>
                            </button>
                            <button
                                id="c2"
                                className="d-flex justify-content-center align-items-center"
                                onClick={clickedBox}
                                disabled={isDisabled || c2Box !== null || win || win === false}
                            >
                                <svg viewBox="31 -4 10 15">
                                    <g
                                        id="Page-1"
                                        stroke="none"
                                        strokeWidth="1"
                                        fill="none"
                                        fillRule="evenodd"
                                    >
                                        <g
                                            id="Group"
                                            strokeLinecap="round"
                                            strokeLinejoin="round"
                                            strokeWidth="1"
                                        >
                                            {c2Box !== null && (
                                                <>
                                                    {c2Box ? (
                                                        renderX()
                                                        ) : (
                                                        renderO()
                                                    )}
                                                </>
                                            )}
                                        </g>
                                    </g>
                                </svg>
                            </button>
                            <button
                                id="c3"
                                className="d-flex justify-content-center align-items-center"
                                onClick={clickedBox}
                                disabled={isDisabled || c3Box !== null || win || win === false}
                            >
                                <svg viewBox="31 -4 10 15">
                                    <g
                                        id="Page-1"
                                        stroke="none"
                                        strokeWidth="1"
                                        fill="none"
                                        fillRule="evenodd"
                                    >
                                        <g
                                            id="Group"
                                            strokeLinecap="round"
                                            strokeLinejoin="round"
                                            strokeWidth="1"
                                        >
                                            {c3Box !== null && (
                                                <>
                                                    {c3Box ? (
                                                        renderX()
                                                        ) : (
                                                        renderO()
                                                    )}
                                                </>
                                            )}
                                        </g>
                                    </g>
                                </svg>
                            </button>
                        </div>

                        <div className="my-5 d-flex justify-content-center">
                            {win !== null || draw ? (
                                <button
                                    className="p-2 rounded-3"
                                    onClick={playAgain}
                                >
                                    Play again!
                                </button>
                            ) : (
                                ""
                            )}
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
}

export default TicTacToe;

if (document.getElementById("TicTacToe")) {
    ReactDOM.render(<TicTacToe />, document.getElementById("TicTacToe"));
}
